
<template>
  <div class="ph-compare-main ">
    <el-backtop ></el-backtop>
    <hpheader ref="headerRef" v-if="showHeader"></hpheader>
    <ph-edit></ph-edit>
  </div>
</template>

<script>
import hpheader from '@/common/hpheader.vue'
import hpfooter from '@/common/hpfooter.vue'
import phEdit from "@/components/compare/ph-edit.vue"

export default {
  components: {
    hpfooter,
    hpheader,
    phEdit
  },
  data() {
    return {
      showHeader: true,
      is_mounted: false,
      headerHeight: 0
    }
  },
  async mounted() {
    let _this = this
    this.$nextTick(async () => {
      _this.is_mounted = true
    })

    await _this.$nextTick()

    // _this.footerHeight = _this.$refs.footerRef.$el.offsetHeight
    _this.headerHeight = _this.$refs.headerRef.$el.offsetHeight
  },
  methods: {

  },
}
</script>

<style scoped>

</style>